/**
 * Consomme la réponse API pré-chargée depuis index.html (inline script).
 * Réduit le délai de découverte LCP (~1,5 s en prod).
 */

const HOME_PREFETCH_KEY = "__AWLO_HOME_PREFETCH__";
const HOME_PREFETCH_PROMISE_KEY = "__AWLO_HOME_PREFETCH_PROMISE__";

function getWindow() {
  return typeof window !== "undefined" ? window : null;
}

/** @param {Record<string, unknown>} filters */
function isDefaultHomeFilters(filters = {}) {
  const keys = Object.keys(filters).filter(
    (k) => k !== "status" && k !== "photos" && k !== "_and"
  );
  if (keys.length > 0) return false;
  return filters.status?._eq === "published" && filters.photos?._nnull === true;
}

/**
 * @param {Object} params — paramètres LogementService.getAll
 */
export function isDefaultHomeListRequest(params = {}) {
  if (params.page !== 1 && params.page !== undefined) return false;
  if (params.isPublic !== true) return false;
  if (!isDefaultHomeFilters(params.filters || {})) return false;
  if (params.fields && String(params.fields).includes("favoris")) return false;

  const win = getWindow();
  const meta = win?.__AWLO_HOME_PREFETCH_META__;
  if (meta?.limit && params.limit && meta.limit !== params.limit) return false;

  // Ne pas consommer le prefetch si la limite photos demandée ne correspond pas
  const requestedPhotosLimit = params.deep?.photos?._limit;
  if (
    requestedPhotosLimit != null &&
    meta?.photosLimit != null &&
    requestedPhotosLimit !== meta.photosLimit
  ) {
    return false;
  }

  return true;
}

/**
 * @param {Object} params
 * @returns {Promise<{ data: Array, meta: Object } | null>}
 */
export async function consumeHomePrefetch(params = {}) {
  if (!isDefaultHomeListRequest(params)) return null;

  const win = getWindow();
  if (!win) return null;

  if (win[HOME_PREFETCH_KEY]) {
    const payload = win[HOME_PREFETCH_KEY];
    delete win[HOME_PREFETCH_KEY];
    delete win[HOME_PREFETCH_PROMISE_KEY];
    delete win.__AWLO_HOME_PREFETCH_META__;
    return payload;
  }

  if (win[HOME_PREFETCH_PROMISE_KEY]) {
    try {
      const payload = await win[HOME_PREFETCH_PROMISE_KEY];
      delete win[HOME_PREFETCH_PROMISE_KEY];
      delete win.__AWLO_HOME_PREFETCH_META__;
      if (payload?.data?.length) return payload;
    } catch {
      delete win[HOME_PREFETCH_PROMISE_KEY];
    }
  }

  return null;
}
